export const URI_FILE = 'file';
